<template>
  <div>
    <a-modal
      :visible="visible"
      :title="modalTit"
      on-ok="handleOk"
      :mask-closable="false"
      :ok-text="okTTxt"
      :cancel-text="cancelTxt"
      width="440px"
      :confirm-loading="confirmLoading"
      @ok="onSave"
      @cancel="onClose"
    >
      <a-form
        :form="form"
        hide-required-mark
      >
        <!-- <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="主管："
        >
          <a-button
            size="small"
            class="edit-btn"
            @click="editLeader"
          >
            编辑
          </a-button>
          <p class="editleader-p">
            <a-tag
              v-for="(item,index) in teamSetLeaderListLocal"
              :key="index"
            >
              {{ item.truename }}
            </a-tag>
          </p>
        </a-form-item> -->
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${directorTit}：`"
        >
          <a-select
            class="search-select"
            mode="multiple"
            :placeholder="selectPlaceholder"
            :value="defaultValues"
            @change="handleChangegroup"
          >
            <a-icon
              slot="suffixIcon"
              type="search"
            />
            <a-select-option
              v-for="(items,groupIndex) in remainMembers"
              :key="groupIndex"
              :value="items.truename+'-'+items.userid"
            >
              {{ items.truename }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="teamSetPermissionList.length"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${directorLimitTit}：`"
        >
          <div
            v-for="(item,index) in permissionDatas"
            :key="index+item.label"
            class="editleader-p"
          >
            <div>
              <a-checkbox
                :indeterminate="item.indeterminate"
                :checked="item.selected"
                @change="onCheckAllChange($event,item,index)"
              >
                {{ item.label }}
              </a-checkbox>
            </div>
            <a-checkbox-group
              v-model="item.defaultSelect"
              class="margin-left-16"
              :options="item.child"
              @change="onChange($event,item,index)"
            />
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
// import EditLeader from './EditPermissionMember'
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 }
}
export default {
  components: {
  },
  data () {
    return {
      formItemLayout,
      form: this.$form.createForm(this),
      visible: false,
      plainOptions: [],
      selectedValues: [],
      permissionDatas: [],
      teamSetLeaderListLocal: [],
      remainMembers: [],
      defaultValues: [],
      subData: [],
      confirmLoading: false
    }
  },
  computed: {
    ...mapState('team/manage', ['teamSetSaveLoading', 'teamSetList', 'teamSetVisible', 'teamSetLeaderList', 'selectTreenDataKey', 'teamSetPermissionList']),
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    modalTit () {
      return this.$t('message["1230"]')
    },
    directorTit () {
      return this.$t('message["1715"]')
    },
    directorLimitTit () {
      return this.$t('message["1631"]')
    }
  },
  watch: {
    teamSetVisible (val) {
      this.visible = val
    },
    teamSetLeaderList (val) {
      if (!val) return
      this.subData = val.map(item => item.userid)
    },
    teamSetPermissionList (val) {
      if (val) {
        this.permissionDatas = this.formatePermissionDatas(val)
      }
    },
    visible (val) {
      if (val) {
        if (!this.selectTreenDataKey) return
        const roleArr = this.selectTreenDataKey.split('-')
        this.fetchGetTeamSetLeaderDatas({ roleid: roleArr[1] })
      }
    },
    teamSetList (val) {
      if (!val) return
      this.remainMembers = val
      this.defaultValues = this.getDefaultDatas(this.teamSetLeaderList)
    }
  },
  methods: {
    ...mapActions('team/manage', ['changeEditLeaderDialog', 'changeTeamSetSaveLoading', 'changeTeamSetVisible', 'fetchTeamMemberDatas', 'fetchGetTeamSetLeaderDatas', 'fetchSaveTeamSetLeaderDatas', 'fetchGetTeamSetPermissionList', 'fetchSaveTeamSetPermissionList']),
    showDrawer () {
      this.visible = true
    },
    formatePermissionDatas (value) {
      let tempArray = []
      if (Array.isArray(value)) {
        value.map(values => {
          const json = {
            label: values.name,
            value: values.id,
            indeterminate: false,
            disabled: !values.cancel,
            selected: values.selected,
            defaultSelect: [],
            child: []
          }
          if (values.child) {
            values.child.map((item, index) => {
              if (item.selected) {
                json.defaultSelect.push(item.id)
              }
              json.child.push({
                label: item.name,
                value: item.id,
                selected: item.selected,
                disabled: !item.cancel
              })
            })
          }
          tempArray.push(json)
        })
      }
      return tempArray
    },
    onChange (checkedList, item, index) {
      item.indeterminate = !!checkedList.length && (checkedList.length < item.child.length)
      item.selected = checkedList.length === item.child.length
      this.$set(this.permissionDatas, index, item)
    },
    onCheckAllChange (e, item, index) {
      if (Array.isArray(item.child)) {
        item.child.map((value, indexchild) => {
          value.selected = e.target.checked
          item.defaultSelect.push(value.value)
        })
      }
      if (!e.target.checked) {
        item.defaultSelect = []
      }
      item.indeterminate = false
      item.selected = e.target.checked
      this.$set(this.permissionDatas, index, item)
    },
    onClose () {
      this.changeTeamSetVisible(false)
      this.changeTeamSetSaveLoading(false)
    },
    async onSave () {
      if (!this.selectTreenDataKey) return
      this.changeTeamSetSaveLoading(true)
      const roleArr = this.selectTreenDataKey.split('-')
      const chain = await this.fetchSaveTeamSetLeaderDatas({ roleid: roleArr[1], leader: this.subData })
      chain.onSuccess(raw => {
      })
      // const roleArr = this.selectTreenDataKey.split('-')
      // this.fetchSaveTeamSetPermissionList({ roleid: roleArr[1], permission: this.getSelectedId() })
      setTimeout(() => {
        this.fetchTeamMemberDatas(roleArr[1])
      })
    },
    getUserid (array) {
      return array.map(value => value.userid)
    },
    getSelectedId () {
      let selectedId = []
      if (Array.isArray(this.permissionDatas)) {
        this.permissionDatas.map(value => {
          if (value.selected) {
            selectedId.push(value.value)
          }
          selectedId = selectedId.concat(value.defaultSelect)
        })
      }
      return selectedId
    },
    getDefaultDatas (data) {
      let tempv = []
      if (Array.isArray(data)) {
        data.map(value => {
          tempv.push((value.truename + '-' + value.userid))
        })
      }
      return tempv
    },
    handleChangegroup (val) {
      this.defaultValues = val
      this.teamLeaderList = []
      let subData = []
      if (Array.isArray(val)) {
        val.map(value => {
          const tep = value.split('-')
          subData.push(tep[1])
          this.teamLeaderList.push({ truename: tep[0], userid: tep[1] })
        })
      }
      this.subData = subData
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-btn {
  margin-bottom: 14px;
  margin-left: 16px;
}
.editleader-p {
  margin-left: 16px;
}
.team-seting-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background-color: #fff;
  text-align: left;
  .save-btn {
    margin-left: 106px;
    margin-right: 16px;
  }
}

.checkbox-group-p {
  width: 500px;
  .parent-span {
    width: 150px;
    .child-permission {
      margin-left: 24px;
      span {
        display: inline-block;
      }
    }
  }
}
.margin-left-16 {
  margin-left: 16px;
}
</style>
